import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=06b3f78a&scoped=true"
import script from "./Paginacao.vue?vue&type=script&lang=js"
export * from "./Paginacao.vue?vue&type=script&lang=js"
import style0 from "./Paginacao.vue?vue&type=style&index=0&id=06b3f78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3f78a",
  null
  
)

export default component.exports